import { Component, forwardRef, ElementRef, ViewChild, ChangeDetectorRef, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../../@core/abstract-workflow-form-component';
import { SoudotecEmplacementInputModel } from '../soudotec-emplacement-input.model';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { MatDialog } from '@angular/material/dialog';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { SoudotecEmplacementInputService } from '../soudotec-emplacement-input.service';

@Component({
    selector: 'soudotec-emplacement-input-form',
    providers: [
      {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => SoudotecEmplacementInputFormComponent),
          multi: true
      },
      {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => SoudotecEmplacementInputFormComponent),
          multi: true
      }
    ],
    templateUrl: './soudotec-emplacement-input-form.component.html',
    styleUrls: ['./soudotec-emplacement-input-form.component.scss']
})
export class SoudotecEmplacementInputFormComponent extends AbstractWorkflowFormComponent<SoudotecEmplacementInputModel, any> {
  component: Model_WorkflowComponent;

  constructor(
    private dialog: MatDialog,
    private _soudotecEmplacementService: SoudotecEmplacementInputService,
    _workflowComponentsService: WorkflowComponentsService,
    _cdf: ChangeDetectorRef,
    _injector: Injector
  ) {
    super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.component = this.model.additional as Model_WorkflowComponent;
  }

  onScanned(_scannedCode: string) {
    if (!_scannedCode) { return; }
    this.onValueChanged(_scannedCode);
  }
}